import styled from "styled-components";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* padding: 0 0 700px 0; */
`;
export const Wrapper = styled.div`
  display: flex;
`;
